/**
 * AlmadarPostWhatIfSoftwareCouldBuildItselfENAlmadarPostWhatIfSoftwareCouldBuildItselfENPage
 *
 * Page component for AlmadarPostWhatIfSoftwareCouldBuildItselfENAlmadarPostWhatIfSoftwareCouldBuildItselfENPage
 * Path: /blog/what-if-software-could-build-itself
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView as __AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfENPostAnalyticsView as __AlmadarPostWhatIfSoftwareCouldBuildItselfENPostAnalyticsView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWhatIfSoftwareCouldBuildItselfENAlmadarPostWhatIfSoftwareCouldBuildItselfENPageProps {
  // Add any page-level props here
}

export function AlmadarPostWhatIfSoftwareCouldBuildItselfENAlmadarPostWhatIfSoftwareCouldBuildItselfENPage(_props: AlmadarPostWhatIfSoftwareCouldBuildItselfENAlmadarPostWhatIfSoftwareCouldBuildItselfENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWhatIfSoftwareCouldBuildItselfENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWhatIfSoftwareCouldBuildItselfENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWhatIfSoftwareCouldBuildItselfENAlmadarPostWhatIfSoftwareCouldBuildItselfENPage;
